import React from "react";
import styles from "./AppCheckbox.module.scss";

interface AppCheckboxProps {
  label: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  isToggled?: boolean;
  darkCheckbox?: boolean;
}

const AppCheckbox: React.FC<AppCheckboxProps> = ({
  label,
  checked,
  onChange,
  className,
  isToggled,
  darkCheckbox,
}) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  const handleButtonClick = () => {
    onChange(!checked);
  };

  return (
    <label
      className={`${styles.checkboxContainer} ${
        darkCheckbox ? styles.darkMode : ""
      }`}
    >
      {!isToggled ? (
        <React.Fragment>
          <input
            type="checkbox"
            checked={checked}
            onChange={handleCheckboxChange}
            className="absolute opacity-0 cursor-pointer"
          />
          <span
            className={`${styles.checkmark} ${className} ${
              darkCheckbox ? styles.darkCheckmark : ""
            }`}
          ></span>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <input
            type="checkbox"
            checked={checked}
            onChange={handleCheckboxChange}
            className="!absolute !opacity-0 !w-0 !h-0 cursor-pointer"
          />
          <button
            type="button"
            onClick={handleButtonClick}
            className={`w-7 h-7 flex items-center justify-center rounded-full border me-2 cursor-pointer transition-all duration-200 
              ${
               checked
                  ? "bg-primary text-white border-[#ddd]"
                  : "bg-white text-primary border-[#ddd]"
              }`}
          >
            <span className="text-xl font-bold">{checked ? "-" : "+"}</span>
          </button>
        </React.Fragment>
      )}
      {label}
    </label>
  );
};

export default AppCheckbox;
